import styled from 'styled-components'

export const ConsentContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
`

export const ImageClientContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

export const ImageClient = styled.div`
  border: 2px solid var(--primary500);
  border-radius: 5px;
  overflow: hidden;
  width: 100px;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: 100%;
  }
`

export const ConsentList = styled.ul`
  .lista-item {
    border-bottom: 1px solid var(--gray100);
    padding: 12px 0px;
  }
`
